/* eslint-disable @typescript-eslint/no-unsafe-assignment, react/display-name, react/jsx-indent */
import React from 'react';
import { EventProps } from 'react-big-calendar';
import { DayEvent, MonthEvent, WeekEvent } from '../CalendarEventComponents';
import { DualTimezoneGutterHeader, DualTimezoneSlotWrapper } from '../../Dualtimezone/Dualtimezonegutter';
import { CalendarEventType } from '../../CalendarEventType';

export interface UseCalendarComponentsParams {
  showDualGutter: boolean;
  primaryTimezone?: any;
  secondaryTimezone?: any;
  activeTab?: any;
  checkedPositions?: string[];
  administrationCalendar: boolean;
  openAppointmentDrawerUpdateBooking: (availability: any) => void;
}

export const useCalendarComponents = ({
  showDualGutter,
  primaryTimezone,
  secondaryTimezone,
  activeTab,
  checkedPositions,
  administrationCalendar,
  openAppointmentDrawerUpdateBooking,
}: UseCalendarComponentsParams) => {
  return React.useMemo(
    () => ({
      timeGutterHeader:
        showDualGutter && primaryTimezone && secondaryTimezone
          ? /* istanbul ignore next */ () => (
              <DualTimezoneGutterHeader primaryTimezone={primaryTimezone} secondaryTimezone={secondaryTimezone} />
            )
          : undefined,

      timeSlotWrapper:
        showDualGutter && primaryTimezone && secondaryTimezone
          ? /* istanbul ignore next */ (props: any) => (
              <DualTimezoneSlotWrapper {...props} primaryTimezone={primaryTimezone} secondaryTimezone={secondaryTimezone} />
            )
          : undefined,

      day: {
        event: ({ event }: EventProps<CalendarEventType>) => (
          <DayEvent event={event} activeTab={activeTab} checkedPositions={checkedPositions} />
        ),
      },

      week: {
        event: ({ event }: EventProps<CalendarEventType>) => (
          <WeekEvent event={event} activeTab={activeTab} checkedPositions={checkedPositions} />
        ),
      },

      month: {
        event: ({ event }: EventProps<CalendarEventType>) => (
          <MonthEvent
            event={event}
            activeTab={activeTab}
            checkedPositions={checkedPositions}
            administrationCalendar={administrationCalendar}
            openAppointmentDrawerUpdateBooking={openAppointmentDrawerUpdateBooking}
          />
        ),
      },
    }),
    [
      showDualGutter,
      primaryTimezone,
      secondaryTimezone,
      activeTab,
      checkedPositions,
      administrationCalendar,
      openAppointmentDrawerUpdateBooking,
    ],
  );
};
